import axios from "axios";

// Set base URL from environment variable
const baseURL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:4401'
axios.defaults.baseURL = baseURL

// Debug log
console.log('[Axios] Base URL:', baseURL)

axios.defaults.headers.common['Authorization'] = localStorage.getItem('token');
